/* ==========================================================================
   STICK'IT — OUTIL CASQUE : texte sur la photo, transformé façon Photoshop.
   Trois modes, comme Édition > Transformation :
   - Transformer : déplacer, mettre à l'échelle (coins = proportionnel, Maj = libre,
     Alt = depuis le centre), étirer (bords), pivoter (Maj = par 15°) ; Ctrl + coin
     = torsion, Ctrl + bord = inclinaison.
   - Torsion : chaque coin (ou bord) se déplace librement.
   - Déformation : maillage de Bézier 4 × 4 (16 points de contrôle) : carrés = coins,
     ronds = tangentes, glisser dans la grille déforme la zone saisie ; styles
     prédéfinis (arc, drapeau, renflement…) avec courbure.
   Le texte est rendu sur un calque, puis plaqué sur le maillage (triangles
   affines) : l'aperçu et le PNG exporté pour l'atelier sont le même rendu.
   Dépend de window.StickIt.cart (stickit.js).
   ========================================================================== */
(function () {
  'use strict';
  var doc = document;
  var box = doc.querySelector('[data-helmet-custom]');
  if (!box) return;
  function $(s, c) { return (c || doc).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || doc).querySelectorAll(s)); }
  function clamp(v, a, b) { return Math.max(a, Math.min(b, v)); }

  var STYLES = {
    novocane: { label: 'style Novocare', price: 35, family: "'Novocane'" },
    necrosarqe: { label: 'style Death Metal', price: 35, family: "'NecroSarqe'" },
    trashcrush: { label: 'Trash Crush', price: 35, family: "'TrashCrush'" }
  };
  var FONT_FACTOR = 0.15;            // taille de base du texte = largeur de la scène × ce facteur
  var EXPORT_W = 1400, EXPORT_H = 1050;
  var GRID_C = 24, GRID_R = 12;      // finesse du rendu (cases du maillage peint)
  var STORE = 'stickit_hc_state_v2', OLD_STORE = 'stickit_hc_state_v1';
  var SVGNS = 'http://www.w3.org/2000/svg';

  /* ---------------------------------------------------------------- maillage de Bézier
     16 points en coordonnées normalisées (boîte du texte = [-0,5 ; 0,5]²),
     index j*4+i (i = colonne, j = ligne). Surface : S(u,v) = Σ Bi(u)·Bj(v)·Pij. */
  function bern(t) { var s = 1 - t; return [s * s * s, 3 * t * s * s, 3 * t * t * s, t * t * t]; }
  function identity() { var m = []; for (var j = 0; j < 4; j++) for (var i = 0; i < 4; i++) m.push({ x: -0.5 + i / 3, y: -0.5 + j / 3 }); return m; }
  function cloneMesh(m) { return m.map(function (p) { return { x: p.x, y: p.y }; }); }
  function patch(m, u, v) {
    var bu = bern(u), bv = bern(v), x = 0, y = 0;
    for (var j = 0; j < 4; j++) for (var i = 0; i < 4; i++) { var w = bu[i] * bv[j]; x += w * m[j * 4 + i].x; y += w * m[j * 4 + i].y; }
    return { x: x, y: y };
  }
  function isIdentity(m) { var id = identity(); return m.every(function (p, k) { return Math.abs(p.x - id[k].x) < 1e-6 && Math.abs(p.y - id[k].y) < 1e-6; }); }
  var CORNERS = { tl: 0, tr: 3, bl: 12, br: 15 };
  var TANGENTS_OF = { 0: [1, 4], 3: [2, 7], 12: [8, 13], 15: [11, 14] };
  var TANGENTS = [1, 2, 4, 7, 8, 11, 13, 14];

  /* Styles prédéfinis (comme le menu « Déformation » de Photoshop) : déplacement
     vertical des points de contrôle, amplitude 1 = hauteur du texte × courbure. */
  var C = [0, 4 / 3, 4 / 3, 0], F = [0, 1.73, -1.73, 0], S = [1, 1, -1, -1];
  var PRESETS = {
    arc: function (i) { return -C[i]; },
    arcLower: function (i, j) { return C[i] * (j / 3); },
    arcUpper: function (i, j) { return -C[i] * (1 - j / 3); },
    bulge: function (i, j) { return C[i] * (2 * j / 3 - 1); },
    flag: function (i) { return F[i]; },
    rise: function (i) { return S[i]; }
  };
  function presetMesh(name, bend) {
    var m = identity(), f = PRESETS[name];
    if (!f) return m;
    m.forEach(function (p, k) { p.y += f(k % 4, (k / 4) | 0) * bend; }); // 100 % = déplacement d'une hauteur de texte
    return m;
  }

  /* ---------------------------------------------------------------- DOM */
  var stage = $('[data-hc-stage]', box), frame = $('[data-hc-frame]', box), canvas = $('[data-hc-canvas]', box);
  var overlay = $('[data-hc-overlay]', box), input = $('[data-hc-input]', box);
  var fontBtns = $$('[data-hc-font]', box), sideBtns = $$('[data-hc-side]', box), colorBtns = $$('[data-hc-color]', box);
  var modeBtns = $$('[data-hc-mode]', box), presetSel = $('[data-hc-preset]', box), bendIn = $('[data-hc-bend]', box);
  var bendOut = $('[data-hc-bend-out]', box), warpOpts = $('[data-hc-warp-opts]', box);
  var resetBtn = $('[data-hc-reset]', box), addBtn = $('[data-hc-add]', box), priceEl = $('[data-hc-price]', box);
  var colorNameEl = $('[data-hc-color-name]', box), stageImg = $('img', stage);
  var previewBtn = $('[data-hc-preview]', box), pv = $('[data-hc-pv]', box);
  if (!stage || !frame || !canvas || !overlay || !input) return;

  var st = { font: 'novocane', color: '#FFFFFF', holo: false, reflect: false, surcharge: 0, side: 'left',
    x: 50, y: 55, rot: 0, sx: 1, sy: 1, mesh: identity(), mode: 'transform', preset: 'custom', bend: 50 };
  function text() { return (input.value || '').slice(0, 8); }

  /* ---------------------------------------------------------------- texte source */
  var measureCtx = doc.createElement('canvas').getContext('2d');
  function family() { return (STYLES[st.font] || STYLES.novocane).family + ', sans-serif'; }
  function measure(fontPx) { // taille naturelle (apparente) du texte à cette taille de police
    measureCtx.font = fontPx + 'px ' + family();
    return { w: Math.max(4, measureCtx.measureText(text().toUpperCase()).width), h: Math.max(4, fontPx * 0.86) };
  }
  var srcCache = { key: null };
  function source(fontPx) {
    var key = [text(), st.font, st.color, st.holo, st.reflect, Math.round(fontPx / 8)].join('|');
    if (srcCache.key === key) return srcCache;
    var t = text().toUpperCase(), m = measure(fontPx), pad = Math.ceil(fontPx * 0.3);
    var c = doc.createElement('canvas');
    c.width = Math.ceil(m.w) + pad * 2; c.height = Math.ceil(m.h) + pad * 2;
    var x = c.getContext('2d');
    x.textAlign = 'center'; x.textBaseline = 'middle'; x.font = fontPx + 'px ' + family();
    // pas d'ombre dans le calque : semi-transparente, elle marquerait les jonctions du maillage ;
    // l'aperçu reçoit son ombre en CSS (.hc-canvas), le PNG de l'atelier reste net
    if (st.holo || st.reflect) {
      var g = x.createLinearGradient(pad, 0, pad + m.w, 0);
      var stops = st.holo ? ['#8FD9FF', '#C9A8FF', '#FFB3D9', '#FFE49A', '#9BFFD0']
        : ['#9A9AA2', '#E8E8ED', '#FFFFFF', '#D2D2D8', '#ABABB2', '#FFFFFF', '#C7C7CE', '#9A9AA2'];
      stops.forEach(function (s, i, a) { g.addColorStop(i / (a.length - 1), s); });
      x.fillStyle = g;
    } else x.fillStyle = st.color || '#FFFFFF';
    x.fillText(t, c.width / 2, c.height / 2);
    srcCache = { key: key, canvas: c, w: m.w, h: m.h, pad: pad, fontPx: fontPx };
    return srcCache;
  }

  /* ---------------------------------------------------------------- géométrie
     g = boîte du texte sur une scène de largeur W (px) : taille, centre, rotation. */
  function geo(W, H) {
    var base = measure(W * FONT_FACTOR), r = st.rot * Math.PI / 180;
    return { W: W, H: H, base: W * FONT_FACTOR, w: base.w * st.sx, h: base.h * st.sy, cx: st.x / 100 * W, cy: st.y / 100 * H, cos: Math.cos(r), sin: Math.sin(r) };
  }
  function toScreen(p, g) { var lx = p.x * g.w, ly = p.y * g.h; return { x: g.cx + lx * g.cos - ly * g.sin, y: g.cy + lx * g.sin + ly * g.cos }; }
  function toLocal(sx, sy, g) { var dx = sx - g.cx, dy = sy - g.cy; return { x: dx * g.cos + dy * g.sin, y: -dx * g.sin + dy * g.cos }; }
  function toNorm(sx, sy, g) { var l = toLocal(sx, sy, g); return { x: l.x / g.w, y: l.y / g.h }; }
  function boundary(m, n) { // contour échantillonné (sens horaire)
    var pts = [], k;
    for (k = 0; k <= n; k++) pts.push(patch(m, k / n, 0));
    for (k = 1; k <= n; k++) pts.push(patch(m, 1, k / n));
    for (k = n - 1; k >= 0; k--) pts.push(patch(m, k / n, 1));
    for (k = n - 1; k > 0; k--) pts.push(patch(m, 0, k / n));
    return pts;
  }
  function bounds(m) {
    var b = { x0: Infinity, y0: Infinity, x1: -Infinity, y1: -Infinity };
    boundary(m, 16).forEach(function (p) { b.x0 = Math.min(b.x0, p.x); b.y0 = Math.min(b.y0, p.y); b.x1 = Math.max(b.x1, p.x); b.y1 = Math.max(b.y1, p.y); });
    return b;
  }

  /* ---------------------------------------------------------------- rendu (triangles affines) */
  function affine(s1, s2, s3, d1, d2, d3) {
    var det = s1.x * (s2.y - s3.y) + s2.x * (s3.y - s1.y) + s3.x * (s1.y - s2.y);
    if (Math.abs(det) < 1e-9) return null;
    function solve(a, b, c) {
      return [(a * (s2.y - s3.y) + b * (s3.y - s1.y) + c * (s1.y - s2.y)) / det,
        (a * (s3.x - s2.x) + b * (s1.x - s3.x) + c * (s2.x - s1.x)) / det,
        (a * (s2.x * s3.y - s3.x * s2.y) + b * (s3.x * s1.y - s1.x * s3.y) + c * (s1.x * s2.y - s2.x * s1.y)) / det];
    }
    var X = solve(d1.x, d2.x, d3.x), Y = solve(d1.y, d2.y, d3.y);
    return { a: X[0], c: X[1], e: X[2], b: Y[0], d: Y[1], f: Y[2] };
  }
  function tri(ctx, img, s1, s2, s3, d1, d2, d3) {
    var m = affine(s1, s2, s3, d1, d2, d3); if (!m) return;
    // découpe légèrement élargie autour du centre du triangle : pas de fines lignes entre triangles
    var cx = (d1.x + d2.x + d3.x) / 3, cy = (d1.y + d2.y + d3.y) / 3;
    function grow(p) { var dx = p.x - cx, dy = p.y - cy, l = Math.hypot(dx, dy) || 1; return { x: p.x + dx / l * 1.2, y: p.y + dy / l * 1.2 }; }
    var a = grow(d1), b = grow(d2), c = grow(d3);
    ctx.save(); ctx.beginPath(); ctx.moveTo(a.x, a.y); ctx.lineTo(b.x, b.y); ctx.lineTo(c.x, c.y); ctx.closePath(); ctx.clip();
    ctx.setTransform(m.a, m.b, m.c, m.d, m.e, m.f); ctx.drawImage(img, 0, 0); ctx.restore();
  }
  // peint le texte transformé sur ctx (scène W × H, échelle = pixels de ctx par pixel de scène)
  function paint(ctx, W, H, scale) {
    if (!text()) return;
    var g = geo(W, H);
    var fontPx = Math.min(g.base * Math.max(st.sx, st.sy, 1) * scale * 1.3, 900);
    var src = source(fontPx);
    var grid = [], j, i;
    for (j = 0; j <= GRID_R; j++) {
      var row = [];
      for (i = 0; i <= GRID_C; i++) {
        var u = i / GRID_C, v = j / GRID_R, p = toScreen(patch(st.mesh, u, v), g);
        row.push({ d: { x: p.x * scale, y: p.y * scale }, s: { x: src.pad + u * src.w, y: src.pad + v * src.h } });
      }
      grid.push(row);
    }
    for (j = 0; j < GRID_R; j++) for (i = 0; i < GRID_C; i++) {
      var a = grid[j][i], b = grid[j][i + 1], c = grid[j + 1][i], d = grid[j + 1][i + 1];
      tri(ctx, src.canvas, a.s, b.s, c.s, a.d, b.d, c.d);
      tri(ctx, src.canvas, b.s, d.s, c.s, b.d, d.d, c.d);
    }
    ctx.setTransform(1, 0, 0, 1, 0, 0);
  }

  /* ---------------------------------------------------------------- aperçu + poignées */
  var handleEls = {}, hitPath = null, raf = 0;
  function stageSize() { var r = stage.getBoundingClientRect(); return { W: r.width || 1, H: r.height || 1 }; }
  function draw() {
    raf = 0;
    syncNums();
    var s = stageSize(), dpr = Math.min(window.devicePixelRatio || 1, 2.5);
    var cw = Math.round(s.W * dpr), ch = Math.round(s.H * dpr);
    if (canvas.width !== cw || canvas.height !== ch) { canvas.width = cw; canvas.height = ch; }
    var ctx = canvas.getContext('2d'); ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, cw, ch);
    var has = !!text();
    frame.classList.toggle('empty', !has);
    if (!has) return;
    paint(ctx, s.W, s.H, dpr);
    drawOverlay(s.W, s.H);
  }
  function redraw() { if (!raf) raf = requestAnimationFrame(draw); }

  function svgEl(tag, attrs, parent) { var e = doc.createElementNS(SVGNS, tag); for (var k in attrs) e.setAttribute(k, attrs[k]); (parent || overlay).appendChild(e); return e; }
  function pathOf(pts, close) { return pts.map(function (p, k) { return (k ? 'L' : 'M') + p.x.toFixed(1) + ' ' + p.y.toFixed(1); }).join('') + (close ? 'Z' : ''); }
  function handle(key, cls, title) {
    var h = handleEls[key];
    if (!h) {
      h = doc.createElement('div'); h.className = 'hc-handle ' + cls; h.setAttribute('data-hc-h', key);
      if (title) h.title = title;
      frame.appendChild(h); handleEls[key] = h;
      h.addEventListener('pointerdown', function (ev) { startDrag(ev, 'h:' + key, h); });
    }
    h.hidden = false; return h;
  }
  function place(h, p) { h.style.left = p.x + 'px'; h.style.top = p.y + 'px'; }

  var lines = null;
  function drawOverlay(W, H) {
    var g = geo(W, H), m = st.mesh;
    overlay.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    if (!hitPath) {
      // zone de saisie = forme réelle du texte (déplacer / déformer en glissant dedans) ;
      // créée une seule fois : la recréer pendant un glisser perdrait la capture du pointeur
      hitPath = svgEl('path', { class: 'hc-hit' });
      hitPath.addEventListener('pointerdown', function (ev) { startDrag(ev, st.mode === 'warp' ? 'warp' : 'move', hitPath); });
      lines = svgEl('g', { class: 'hc-lines' });
    }
    while (lines.firstChild) lines.removeChild(lines.firstChild);
    Object.keys(handleEls).forEach(function (k) { handleEls[k].hidden = true; });
    var edge = boundary(m, 24).map(function (p) { return toScreen(p, g); });
    hitPath.setAttribute('d', pathOf(edge, true));
    hitPath.setAttribute('class', 'hc-hit hc-hit-' + st.mode);
    if (st.mode === 'warp') {
      svgEl('path', { d: pathOf(edge, true), class: 'hc-line' }, lines);
      [1 / 3, 2 / 3].forEach(function (t) { // lignes de la grille, comme Photoshop
        var a = [], b = [];
        for (var k = 0; k <= 24; k++) { a.push(toScreen(patch(m, t, k / 24), g)); b.push(toScreen(patch(m, k / 24, t), g)); }
        svgEl('path', { d: pathOf(a), class: 'hc-line hc-line-grid' }, lines); svgEl('path', { d: pathOf(b), class: 'hc-line hc-line-grid' }, lines);
      });
      Object.keys(TANGENTS_OF).forEach(function (c) {
        var a = toScreen(m[c], g);
        TANGENTS_OF[c].forEach(function (t) {
          var p = toScreen(m[t], g);
          svgEl('line', { x1: a.x, y1: a.y, x2: p.x, y2: p.y, class: 'hc-line hc-line-tan' }, lines);
          place(handle('t' + t, 'hc-h-tan', 'Courber ce bord'), p);
        });
        place(handle('a' + c, 'hc-h-anchor', 'Déplacer ce coin'), a);
      });
      return;
    }
    if (st.mode === 'distort') {
      var q = [m[0], m[3], m[15], m[12]].map(function (p) { return toScreen(p, g); });
      svgEl('path', { d: pathOf(q, true), class: 'hc-line' }, lines);
      [['tl', 0], ['tr', 1], ['br', 2], ['bl', 3]].forEach(function (c) { place(handle('d' + c[0], 'hc-h-box', 'Déplacer ce coin'), q[c[1]]); });
      [['t', 0, 1], ['r', 1, 2], ['b', 2, 3], ['l', 3, 0]].forEach(function (e) {
        // côté perpendiculaire trop court : la poignée de bord masquerait le texte (voir Transformer)
        var o = e[0] === 't' || e[0] === 'b' ? [q[0], q[3]] : [q[0], q[1]];
        if (Math.hypot(o[1].x - o[0].x, o[1].y - o[0].y) < 64) return;
        place(handle('d' + e[0], 'hc-h-box hc-h-edge', 'Déplacer ce bord'), { x: (q[e[1]].x + q[e[2]].x) / 2, y: (q[e[1]].y + q[e[2]].y) / 2 });
      });
      return;
    }
    // Transformer : boîte englobante + 8 poignées + rotation
    var b = bounds(m), mx = (b.x0 + b.x1) / 2, my = (b.y0 + b.y1) / 2;
    var P = { tl: [b.x0, b.y0], t: [mx, b.y0], tr: [b.x1, b.y0], r: [b.x1, my], br: [b.x1, b.y1], b: [mx, b.y1], bl: [b.x0, b.y1], l: [b.x0, my] };
    var sp = {}; Object.keys(P).forEach(function (k) { sp[k] = toScreen({ x: P[k][0], y: P[k][1] }, g); });
    svgEl('path', { d: pathOf([sp.tl, sp.tr, sp.br, sp.bl], true), class: 'hc-line' }, lines);
    var top = sp.t, up = { x: g.sin, y: -g.cos }, rp = { x: top.x + up.x * 30, y: top.y + up.y * 30 };
    svgEl('line', { x1: top.x, y1: top.y, x2: rp.x, y2: rp.y, class: 'hc-line hc-line-tan' }, lines);
    var center = toScreen({ x: mx, y: my }, g);
    svgEl('circle', { cx: center.x, cy: center.y, r: 3.5, class: 'hc-ref' }, lines);
    // petit texte (mobile) : les poignées de bord recouvriraient le texte et empêcheraient de le
    // saisir — comme Photoshop sur un petit objet, on ne garde alors que les coins
    var bw = Math.hypot(sp.tr.x - sp.tl.x, sp.tr.y - sp.tl.y), bh = Math.hypot(sp.bl.x - sp.tl.x, sp.bl.y - sp.tl.y);
    Object.keys(P).forEach(function (k) {
      if ((k === 't' || k === 'b') && bh < 64) return;
      if ((k === 'l' || k === 'r') && bw < 64) return;
      place(handle('s' + k, 'hc-h-box' + (k.length === 1 ? ' hc-h-edge' : '') + ' hc-cur-' + k, k.length === 1 ? 'Étirer' : 'Agrandir / réduire (Maj = libre)'), sp[k]);
    });
    place(handle('rot', 'hc-h-rot', 'Pivoter (Maj = par 15°)'), rp);
  }

  /* ---------------------------------------------------------------- interactions */
  var drag = null, history = [];
  function snapshot() { return { x: st.x, y: st.y, rot: st.rot, sx: st.sx, sy: st.sy, mesh: cloneMesh(st.mesh), preset: st.preset, bend: st.bend }; }
  function restore(s) { st.x = s.x; st.y = s.y; st.rot = s.rot; st.sx = s.sx; st.sy = s.sy; st.mesh = cloneMesh(s.mesh); st.preset = s.preset; st.bend = s.bend; syncWarpUi(); redraw(); save(); }
  function pushHistory() { history.push(snapshot()); if (history.length > 40) history.shift(); }

  function pointer(ev) { var r = stage.getBoundingClientRect(); return { x: ev.clientX - r.left, y: ev.clientY - r.top }; }
  function startDrag(ev, kind, el) {
    if (!text()) return;
    ev.preventDefault(); ev.stopPropagation();
    var s = stageSize(), g = geo(s.W, s.H), p = pointer(ev);
    pushHistory(); future = [];
    drag = { kind: kind, el: el, id: ev.pointerId, p0: p, g0: g, st0: snapshot(), b0: bounds(st.mesh) };
    if (kind === 'warp') { // (u,v) du point saisi : échantillon du maillage le plus proche
      var best = Infinity;
      for (var j = 0; j <= 20; j++) for (var i = 0; i <= 30; i++) {
        var q = toScreen(patch(st.mesh, i / 30, j / 20), g), d = (q.x - p.x) * (q.x - p.x) + (q.y - p.y) * (q.y - p.y);
        if (d < best) { best = d; drag.u = i / 30; drag.v = j / 20; }
      }
    }
    if (kind === 'h:rot') {
      var b = drag.b0; drag.c = toScreen({ x: (b.x0 + b.x1) / 2, y: (b.y0 + b.y1) / 2 }, g);
      drag.a0 = Math.atan2(p.y - drag.c.y, p.x - drag.c.x);
    }
    try { el.setPointerCapture(ev.pointerId); } catch (e) {}
    el.addEventListener('pointermove', onMove);
    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
  }
  function endDrag(ev) {
    if (!drag) return;
    var el = drag.el; drag = null;
    try { el.releasePointerCapture(ev.pointerId); } catch (e) {}
    el.removeEventListener('pointermove', onMove); el.removeEventListener('pointerup', endDrag); el.removeEventListener('pointercancel', endDrag);
    save(); redraw();
  }
  function setPreset(name) { st.preset = name; syncWarpUi(); }
  function onMove(ev) {
    if (!drag || ev.pointerId !== drag.id) return;
    var p = pointer(ev), d = drag, g = d.g0, s0 = d.st0, k = d.kind;
    if (k === 'move') {
      var s = stageSize();
      st.x = clamp(s0.x + (p.x - d.p0.x) / s.W * 100, 0, 100);
      st.y = clamp(s0.y + (p.y - d.p0.y) / s.H * 100, 0, 100);
    } else if (k === 'h:rot') {
      var a = Math.atan2(p.y - d.c.y, p.x - d.c.x) - d.a0, deg = s0.rot + a * 180 / Math.PI;
      if (ev.shiftKey) deg = Math.round(deg / 15) * 15;
      deg = ((deg + 180) % 360 + 360) % 360 - 180;
      rotateAbout(d.c, deg, g);
    } else if (k === 'warp') {
      // le point saisi suit exactement le curseur ; les 4 coins restent fixes (solution de norme minimale)
      var n0 = toNorm(d.p0.x, d.p0.y, g), n1 = toNorm(p.x, p.y, g), dx = n1.x - n0.x, dy = n1.y - n0.y;
      var bu = bern(d.u), bv = bern(d.v), w = [], sum = 0, idx;
      for (idx = 0; idx < 16; idx++) { var isC = idx === 0 || idx === 3 || idx === 12 || idx === 15; w[idx] = isC ? 0 : bu[idx % 4] * bv[(idx / 4) | 0]; sum += w[idx] * w[idx]; }
      st.mesh = cloneMesh(s0.mesh);
      if (sum > 1e-9) for (idx = 0; idx < 16; idx++) { st.mesh[idx].x += w[idx] / sum * dx; st.mesh[idx].y += w[idx] / sum * dy; }
      setPreset('custom');
    } else if (k.indexOf('h:a') === 0 || k.indexOf('h:t') === 0) { // ancre (avec ses tangentes) ou tangente seule
      var id = parseInt(k.slice(3), 10), n = toNorm(p.x, p.y, g), o = s0.mesh[id];
      var ddx = n.x - o.x, ddy = n.y - o.y;
      st.mesh = cloneMesh(s0.mesh);
      [id].concat(k.indexOf('h:a') === 0 ? TANGENTS_OF[id] : []).forEach(function (t) { st.mesh[t].x += ddx; st.mesh[t].y += ddy; });
      setPreset('custom');
    } else if (k.indexOf('h:d') === 0) {
      distort(k.slice(3), p, g, s0, false);
    } else if (k.indexOf('h:s') === 0) {
      var key = k.slice(3);
      if (ev.ctrlKey || ev.metaKey) distort(key, p, g, s0, key.length === 1);
      else scale(key, p, g, s0, ev.shiftKey, ev.altKey);
    }
    redraw();
  }
  // torsion : déplace un coin (ou les 2 coins d'un bord) ; poids bilinéaires sur le maillage
  // (précision linéaire de Bernstein : le coin de la surface suit exactement le curseur)
  var CW = { tl: function (i, j) { return (1 - i / 3) * (1 - j / 3); }, tr: function (i, j) { return (i / 3) * (1 - j / 3); },
    bl: function (i, j) { return (1 - i / 3) * (j / 3); }, br: function (i, j) { return (i / 3) * (j / 3); } };
  var EDGE_CORNERS = { t: ['tl', 'tr'], b: ['bl', 'br'], l: ['tl', 'bl'], r: ['tr', 'br'] };
  function distort(key, p, g, s0, skewOnly) {
    var n0 = toNorm(drag.p0.x, drag.p0.y, g), n1 = toNorm(p.x, p.y, g), dx = n1.x - n0.x, dy = n1.y - n0.y;
    if (skewOnly) { if (key === 't' || key === 'b') dy = 0; else dx = 0; }
    var corners = EDGE_CORNERS[key] || [key];
    st.mesh = cloneMesh(s0.mesh);
    st.mesh.forEach(function (q, idx) {
      var i = idx % 4, j = (idx / 4) | 0, w = 0;
      corners.forEach(function (c) { w += CW[c](i, j); });
      q.x += w * dx; q.y += w * dy;
    });
    setPreset('custom');
  }
  // échelle : le point opposé (ou le centre avec Alt) reste fixe à l'écran
  var OPP = { tl: 'br', t: 'b', tr: 'bl', r: 'l', br: 'tl', b: 't', bl: 'tr', l: 'r' };
  function boxPt(key, b) {
    var mx = (b.x0 + b.x1) / 2, my = (b.y0 + b.y1) / 2;
    return { x: /l/.test(key) ? b.x0 : /r/.test(key) ? b.x1 : mx, y: /t/.test(key) ? b.y0 : /b/.test(key) ? b.y1 : my };
  }
  function scale(key, p, g, s0, free, fromCenter) {
    var b = drag.b0, D = boxPt(key, b), A = fromCenter ? { x: (b.x0 + b.x1) / 2, y: (b.y0 + b.y1) / 2 } : boxPt(OPP[key], b);
    var As = toScreen(A, g), r = s0.rot * Math.PI / 180, cos = Math.cos(r), sin = Math.sin(r);
    var vx = p.x - As.x, vy = p.y - As.y, lx = vx * cos + vy * sin, ly = -vx * sin + vy * cos; // curseur dans le repère de la boîte
    var bw = g.w / s0.sx, bh = g.h / s0.sy;                                                         // taille naturelle
    var ex = (D.x - A.x) * bw, ey = (D.y - A.y) * bh;                                               // vecteur ancre -> poignée à l'échelle 1
    var sx = s0.sx, sy = s0.sy;
    if (key.length === 2 && !free) {           // coin : proportionnel par défaut (Maj = libre)
      var k = (lx * ex * s0.sx + ly * ey * s0.sy) / ((ex * s0.sx) * (ex * s0.sx) + (ey * s0.sy) * (ey * s0.sy));
      k = Math.max(k, 0.08); sx = s0.sx * k; sy = s0.sy * k;
    } else {
      if (Math.abs(ex) > 1e-6) sx = lx / ex;
      if (Math.abs(ey) > 1e-6) sy = ly / ey;
    }
    st.sx = clamp(sx, 0.08, 8); st.sy = clamp(sy, 0.08, 8);
    // replace l'origine pour que l'ancre ne bouge pas
    var s = stageSize(), alx = A.x * bw * st.sx, aly = A.y * bh * st.sy;
    var ox = As.x - (alx * cos - aly * sin), oy = As.y - (alx * sin + aly * cos);
    st.x = ox / s.W * 100; st.y = oy / s.H * 100;
  }
  function rotateAbout(c, deg, g) { // pivote autour du centre de la boîte (c, à l'écran)
    var s = stageSize(), b = drag.b0, lc = { x: (b.x0 + b.x1) / 2 * g.w, y: (b.y0 + b.y1) / 2 * g.h };
    var r = deg * Math.PI / 180, cos = Math.cos(r), sin = Math.sin(r);
    st.rot = deg;
    st.x = (c.x - (lc.x * cos - lc.y * sin)) / s.W * 100;
    st.y = (c.y - (lc.x * sin + lc.y * cos)) / s.H * 100;
  }

  /* ---------------------------------------------------------------- modes, styles, annuler */
  function setMode(m) {
    st.mode = m;
    modeBtns.forEach(function (b) { var on = b.getAttribute('data-hc-mode') === m; b.classList.toggle('on', on); b.setAttribute('aria-pressed', String(on)); });
    if (warpOpts) warpOpts.hidden = m !== 'warp';
    var nums = $('[data-hc-nums]', box); if (nums) nums.hidden = m === 'warp';   // en Déformation : style + courbure seulement (comme Photoshop)
    $$('[data-hc-help]', box).forEach(function (u) { u.hidden = u.getAttribute('data-hc-help') !== m; });
    frame.setAttribute('data-mode', m);
    redraw();
  }
  function syncWarpUi() {
    if (presetSel) presetSel.value = st.preset;
    if (bendIn) { bendIn.value = st.bend; bendIn.disabled = st.preset === 'custom'; }
    if (bendOut) bendOut.textContent = Math.round(st.bend) + ' %';
  }
  modeBtns.forEach(function (b) { b.addEventListener('click', function () { setMode(b.getAttribute('data-hc-mode')); save(); }); });

  /* ---------------------------------------------------------------- barre d'options (comme Photoshop)
     X / Y (position du centre, % de la scène), L / H (% de la taille d'origine, chaîne = proportions),
     angle, symétries, annuler / rétablir. Les champs suivent chaque transformation à la souris. */
  var numEls = {}; $$('[data-hc-num]', box).forEach(function (el) { numEls[el.getAttribute('data-hc-num')] = el; });
  var linkBtn = $('[data-hc-link]', box), linked = true, future = [];
  function syncNums() {
    var v = { x: st.x, y: st.y, w: st.sx * 100, h: st.sy * 100, rot: st.rot };
    Object.keys(numEls).forEach(function (k) { if (doc.activeElement !== numEls[k]) numEls[k].value = Math.round(v[k]); });
  }
  Object.keys(numEls).forEach(function (k) {
    var el = numEls[k];
    el.addEventListener('focus', function () { pushHistory(); future = []; });
    el.addEventListener('input', function () {
      var n = parseFloat(el.value); if (!isFinite(n)) return;
      if (k === 'x') st.x = clamp(n, 0, 100);
      else if (k === 'y') st.y = clamp(n, 0, 100);
      else if (k === 'rot') st.rot = ((clamp(n, -360, 360) + 180) % 360 + 360) % 360 - 180;
      else {
        var v = clamp(n, 8, 800) / 100, r = k === 'w' ? v / st.sx : v / st.sy;
        if (k === 'w') st.sx = v; else st.sy = v;
        if (linked && isFinite(r)) { if (k === 'w') st.sy = clamp(st.sy * r, 0.08, 8); else st.sx = clamp(st.sx * r, 0.08, 8); }
      }
      redraw();
    });
    el.addEventListener('change', function () { syncNums(); save(); });
    el.addEventListener('keydown', function (ev) { if (ev.key === 'Enter') { ev.preventDefault(); el.blur(); } });
  });
  if (linkBtn) linkBtn.addEventListener('click', function () {
    linked = !linked; linkBtn.classList.toggle('on', linked); linkBtn.setAttribute('aria-pressed', String(linked));
  });
  // symétries : miroir du maillage autour du centre de la boîte (le texte est retourné, comme Édition > Transformation > Symétrie)
  $$('[data-hc-flip]', box).forEach(function (b) {
    b.addEventListener('click', function () {
      if (!text()) return;
      pushHistory(); future = [];
      var ax = b.getAttribute('data-hc-flip') === 'h' ? 'x' : 'y';
      // chaque point de contrôle passe de l'autre côté de l'axe : le bord gauche du texte se retrouve à droite
      st.mesh = st.mesh.map(function (p) { return { x: ax === 'x' ? -p.x : p.x, y: ax === 'y' ? -p.y : p.y }; });
      setPreset('custom'); redraw(); save();
    });
  });
  function undo() { if (!history.length) return; future.push(snapshot()); restore(history.pop()); }
  function redo() { if (!future.length) return; history.push(snapshot()); restore(future.pop()); }
  var undoBtn = $('[data-hc-undo]', box), redoBtn = $('[data-hc-redo]', box);
  if (undoBtn) undoBtn.addEventListener('click', undo);
  if (redoBtn) redoBtn.addEventListener('click', redo);

  // rotation en glissant juste à l'extérieur du cadre (curseur de rotation), comme dans Photoshop
  var ROT_CURSOR = 'url("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27%3E%3Cpath d=%27M5 15a8 8 0 0 0 14-4%27 fill=%27none%27 stroke=%27%23000%27 stroke-width=%274%27/%3E%3Cpath d=%27M5 15a8 8 0 0 0 14-4%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272%27/%3E%3Cpath d=%27M16 10l3 1 1-3M2 13l3 2 2-3%27 fill=%27none%27 stroke=%27%23fff%27 stroke-width=%272%27/%3E%3C/svg%3E") 12 12, alias';
  function boxPoly(g) {
    var b = bounds(st.mesh);
    return [[b.x0, b.y0], [b.x1, b.y0], [b.x1, b.y1], [b.x0, b.y1]].map(function (c) { return toScreen({ x: c[0], y: c[1] }, g); });
  }
  function nearOutside(p) { // à l'extérieur du cadre, à moins de 46 px de celui-ci
    if (!text() || st.mode !== 'transform') return false;
    var s = stageSize(), q = boxPoly(geo(s.W, s.H)), inside = false, dmin = Infinity;
    for (var i = 0, j = 3; i < 4; j = i++) {
      var a = q[i], c = q[j];
      if ((a.y > p.y) !== (c.y > p.y) && p.x < (c.x - a.x) * (p.y - a.y) / (c.y - a.y) + a.x) inside = !inside;
      var dx = c.x - a.x, dy = c.y - a.y, t = clamp(((p.x - a.x) * dx + (p.y - a.y) * dy) / (dx * dx + dy * dy || 1), 0, 1);
      dmin = Math.min(dmin, Math.hypot(p.x - a.x - t * dx, p.y - a.y - t * dy));
    }
    return !inside && dmin < 46;
  }
  stage.addEventListener('pointermove', function (ev) { if (!drag) stage.style.cursor = nearOutside(pointer(ev)) ? ROT_CURSOR : ''; });
  stage.addEventListener('pointerleave', function () { if (!drag) stage.style.cursor = ''; });
  stage.addEventListener('pointerdown', function (ev) {
    if (ev.target !== stage && ev.target !== stageImg) return;
    if (nearOutside(pointer(ev))) { future = []; startDrag(ev, 'h:rot', stage); }
  });
  if (presetSel) presetSel.addEventListener('change', function () {
    pushHistory(); st.preset = presetSel.value;
    if (st.preset !== 'custom') st.mesh = presetMesh(st.preset, st.bend / 100);
    syncWarpUi(); redraw(); save();
  });
  if (bendIn) {
    bendIn.addEventListener('pointerdown', pushHistory);
    bendIn.addEventListener('input', function () {
      st.bend = parseFloat(bendIn.value) || 0;
      if (st.preset !== 'custom') st.mesh = presetMesh(st.preset, st.bend / 100);
      syncWarpUi(); redraw();
    });
    bendIn.addEventListener('change', save);
  }
  addEventListener('keydown', function (ev) {
    // Échap pendant un glisser : annule le geste en cours (comme Photoshop)
    if (ev.key === 'Escape' && drag) { var d0 = drag; endDrag({ pointerId: d0.id }); history.pop(); restore(d0.st0); return; }
    var z = ev.key.toLowerCase();
    if (!(ev.ctrlKey || ev.metaKey) || (z !== 'z' && z !== 'y')) return;
    var a = doc.activeElement; if (a && /^(INPUT|TEXTAREA)$/.test(a.tagName) && a !== bendIn) return;
    var r = box.getBoundingClientRect(); if (r.bottom < 0 || r.top > innerHeight) return; // seulement quand l'outil est à l'écran
    ev.preventDefault();
    if (z === 'y' || ev.shiftKey) redo(); else undo();   // Ctrl+Z annule · Ctrl+Maj+Z (ou Ctrl+Y) rétablit
  });

  /* ---------------------------------------------------------------- texte, police, couleur, côté */
  function updatePrice() {
    var total = (STYLES[st.font] ? STYLES[st.font].price : 0) + (st.surcharge || 0);
    if (priceEl) { // seul le montant change : le libellé « Prix » (et sa traduction) reste en place
      var tn = priceEl.lastChild && priceEl.lastChild.nodeType === 3 ? priceEl.lastChild : priceEl.appendChild(doc.createTextNode(''));
      tn.nodeValue = total + ' CHF';
    }
    return total;
  }
  function setFont(f) {
    if (!STYLES[f]) return; st.font = f;
    fontBtns.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-hc-font') === f); });
    updatePrice(); redraw();
  }
  // nom FR de la couleur (data-hc-name) : title est traduit par i18n.js, or le panier / Shopify attendent le nom français
  function colorName(b) { return b.getAttribute('data-hc-name') || b.getAttribute('title') || ''; }
  function setColor(btn) {
    st.color = btn.style.background || '#FFFFFF'; st.holo = btn.hasAttribute('data-hc-holo'); st.reflect = btn.hasAttribute('data-hc-reflect');
    st.surcharge = parseFloat(btn.getAttribute('data-hc-surcharge')) || 0;
    if (st.holo || st.reflect) st.color = '#FFFFFF';
    colorBtns.forEach(function (b) { b.classList.toggle('on', b === btn); });
    // affichage traduit par i18n.js ; la valeur française (panier, Shopify, sauvegarde) reste dans data-hc-val
    if (colorNameEl) { colorNameEl.setAttribute('data-hc-val', colorName(btn)); colorNameEl.textContent = colorName(btn); }
    updatePrice(); redraw();
  }
  function setSide(side, animate) {
    var changed = st.side !== side; st.side = side;
    sideBtns.forEach(function (b) { b.classList.toggle('on', b.getAttribute('data-hc-side') === side); });
    var flip = side === 'right';
    if (!animate || !stageImg || !changed) { stage.classList.toggle('flipped', flip); return; }
    stageImg.classList.add('hc-fading');
    setTimeout(function () { stage.classList.toggle('flipped', flip); stageImg.classList.remove('hc-fading'); }, 160);
  }
  function syncAdd() {
    var ok = text().trim().length > 0;
    if (previewBtn) previewBtn.disabled = !ok;
    if (addBtn) { addBtn.disabled = !ok; var sp = addBtn.querySelector('span'); if (sp) sp.textContent = ok ? 'Ajouter au panier' : 'Écris ton texte d’abord'; }
  }
  input.addEventListener('input', function () { syncAdd(); redraw(); save(); });
  fontBtns.forEach(function (b) { b.addEventListener('click', function () { setFont(b.getAttribute('data-hc-font')); save(); }); });
  colorBtns.forEach(function (b) { b.addEventListener('click', function () { setColor(b); save(); }); });
  sideBtns.forEach(function (b) { b.addEventListener('click', function () { setSide(b.getAttribute('data-hc-side'), true); save(); }); });
  if (resetBtn) resetBtn.addEventListener('click', function () {
    pushHistory();
    st.x = 50; st.y = 55; st.rot = 0; st.sx = 1; st.sy = 1; st.mesh = identity(); st.preset = 'custom'; st.bend = 50;
    syncWarpUi(); redraw(); save();
  });

  /* ---------------------------------------------------------------- état mémorisé */
  function save() {
    try {
      localStorage.setItem(STORE, JSON.stringify({ text: input.value, font: st.font, colorTitle: colorNameEl ? (colorNameEl.getAttribute('data-hc-val') || colorNameEl.textContent) : '', side: st.side,
        x: st.x, y: st.y, rot: st.rot, sx: st.sx, sy: st.sy, mesh: st.mesh, mode: st.mode, preset: st.preset, bend: st.bend }));
    } catch (e) {}
  }
  function load() {
    var s = null;
    try { s = JSON.parse(localStorage.getItem(STORE) || 'null') || JSON.parse(localStorage.getItem(OLD_STORE) || 'null'); } catch (e) {}
    if (!s) return;
    var num = function (v, d) { return typeof v === 'number' && isFinite(v) ? v : d; };
    if (s.text) input.value = String(s.text).slice(0, 8);
    if (s.font && STYLES[s.font]) st.font = s.font;
    if (s.side === 'right') st.side = 'right';
    st.x = clamp(num(s.x, 50), 0, 100); st.y = clamp(num(s.y, 55), 0, 100); st.rot = num(s.rot, 0);
    st.sx = clamp(num(s.sx, 1), 0.08, 8); st.sy = clamp(num(s.sy, 1), 0.08, 8);
    if (Array.isArray(s.mesh) && s.mesh.length === 16 && s.mesh.every(function (p) { return p && isFinite(p.x) && isFinite(p.y); })) st.mesh = cloneMesh(s.mesh);
    if (s.mode === 'distort' || s.mode === 'warp') st.mode = s.mode;
    if (s.preset === 'custom' || PRESETS[s.preset]) st.preset = s.preset;
    st.bend = clamp(num(s.bend, 50), -100, 100);
    var cb = colorBtns.filter(function (b) { return colorName(b) === s.colorTitle || b.getAttribute('title') === s.colorTitle; })[0];
    if (cb) setColor(cb);
  }

  /* ---------------------------------------------------------------- export PNG + panier */
  function exportPng() {
    var c = doc.createElement('canvas'); c.width = EXPORT_W; c.height = EXPORT_H;
    paint(c.getContext('2d'), EXPORT_W, EXPORT_H, 1);
    return c.toDataURL('image/png');
  }
  if (addBtn) addBtn.addEventListener('click', function () {
    var t = text().trim(); if (!t || !window.StickIt || !window.StickIt.cart) return;
    var style = STYLES[st.font], colorName = colorNameEl ? (colorNameEl.getAttribute('data-hc-val') || colorNameEl.textContent) : 'Blanc';
    var finish = function () {
      var design = exportPng();
      window.StickIt.cart.add({
        id: 'casque-custom-' + st.font, name: 'Casque personnalisé — ' + style.label,
        variant: 'Texte : ' + t + ' · Couleur : ' + colorName + ' · Côté : ' + (st.side === 'right' ? 'Droite' : 'Gauche'),
        price: updatePrice(), qty: 1, img: design, design: design
      });
    };
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(finish); else finish();
  });

  /* ---------------------------------------------------------------- prévisualisation
     Rendu final, sans cadre ni poignées : la photo du casque (côté choisi) + le texte
     transformé, peint par le même moteur que l'aperçu et le PNG de l'atelier. */
  var pvCanvas = pv && $('[data-hc-pv-canvas]', pv), pvLast = null;
  if (pv) doc.body.appendChild(pv); // hors du configurateur : position fixe sur toute la page
  function renderPreview() {
    var W = pvCanvas.width, H = pvCanvas.height, ctx = pvCanvas.getContext('2d');
    ctx.setTransform(1, 0, 0, 1, 0, 0); ctx.clearRect(0, 0, W, H);
    if (stageImg && stageImg.naturalWidth) { // même cadrage que la photo de l'outil (object-fit: contain)
      var k = Math.min(W / stageImg.naturalWidth, H / stageImg.naturalHeight), iw = stageImg.naturalWidth * k, ih = stageImg.naturalHeight * k;
      ctx.save();
      if (st.side === 'right') { ctx.translate(W, 0); ctx.scale(-1, 1); }
      ctx.drawImage(stageImg, (W - iw) / 2, (H - ih) / 2, iw, ih);
      ctx.restore();
    }
    var layer = doc.createElement('canvas'); layer.width = W; layer.height = H;
    paint(layer.getContext('2d'), W, H, 1);
    // ombre du texte comme dans l'outil (.hc-canvas : drop-shadow)
    ctx.shadowColor = 'rgba(0,0,0,.5)'; ctx.shadowBlur = 14; ctx.shadowOffsetY = 4;
    ctx.drawImage(layer, 0, 0);
    ctx.shadowColor = 'transparent';
  }
  function openPreview() {
    if (!pv || !text().trim()) return;
    var go = function () {
      renderPreview();
      pvLast = doc.activeElement;
      pv.hidden = false; doc.documentElement.classList.add('hc-pv-open');
      requestAnimationFrame(function () { pv.classList.add('on'); });
      var c = $('[data-hc-pv-close]', pv); if (c) c.focus();
    };
    if (stageImg && !stageImg.complete) stageImg.addEventListener('load', go, { once: true });
    else if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(go); else go();
  }
  function closePreview() {
    if (!pv || pv.hidden) return;
    pv.classList.remove('on'); doc.documentElement.classList.remove('hc-pv-open');
    setTimeout(function () { pv.hidden = true; }, 220);
    if (pvLast && pvLast.focus) pvLast.focus();
  }
  if (previewBtn) previewBtn.addEventListener('click', openPreview);
  if (pv) {
    pv.addEventListener('click', function (ev) { if (ev.target === pv || ev.target.closest('[data-hc-pv-close]')) closePreview(); });
    addEventListener('keydown', function (ev) { if (ev.key === 'Escape' && !pv.hidden) closePreview(); });
  }

  /* ---------------------------------------------------------------- démarrage */
  var initial = colorBtns.filter(function (b) { return b.classList.contains('on'); })[0] || colorBtns[0];
  if (initial) setColor(initial);
  load();
  setFont(st.font); setSide(st.side); setMode(st.mode); syncWarpUi(); syncAdd(); updatePrice();
  addEventListener('resize', redraw);
  if (doc.fonts) {
    // le canvas ne dessine avec une police que si elle est chargée : on la demande, puis on redessine
    Object.keys(STYLES).forEach(function (k) { try { doc.fonts.load('40px ' + STYLES[k].family); } catch (e) {} });
    doc.fonts.ready.then(function () { srcCache.key = null; redraw(); });
  }
  redraw();
  window.StickitHelmet = { state: st, exportPng: exportPng, presetMesh: presetMesh, patch: patch, isIdentity: isIdentity };
})();
